import React, { useEffect, useState } from 'react';
import Moment from 'react-moment';
import ProfileBox from '../../Components/ProfileBox/ProfileBox';
import { teacherResponse, getClass, parseTime } from '../../Helper';
import CancelButton from '../../Components/Buttons/CancelButton';
import ConfirmButton from '../../Components/Buttons/ConfirmButton';
import { API } from '../../API';
import { Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
require('./Dashboard.css');

const JobComponent = ({ job, bookings, campuses, insts, response, submitResponse, user_id }) => {
  // const [campus, setCampus] = useState({});
  const [campusAddress, setCampusAddress] = useState([]);
  const [inst, setInst] = useState({});
  const [isOverlap, setIsOverlap] = useState(false);

  // console.log('job', job);

  useEffect(() => {
    // console.log("bookings: ", bookings)
    // check to see if there is an accepted job overlapping
    for (var i = 0; i < bookings.length; i++) {
      if (
        bookings[i].teacher_response == 'accepted' &&
        bookings[i].booking_date == job.booking_date &&
        bookings[i]._id !== job._id
      ) {
        if (checkOverlap(bookings[i], job)) {
          setIsOverlap(true);
          break;
        }
      }
    }
  }, [bookings]);


  useEffect(() => {
    let campus = campuses.find(item => item._id.toString() === job.campus_id.toString())

    if(!campus || !campus._id && job?.campus) {
      campus = job.campus
    }

    setCampusAddress(
      [campus?.address_line1, campus?.address_line2, campus?.suburb, campus?.state].filter(
        (ele) => !!ele
      )
    );
    const inst = insts.find(item => item._id.toString() === campus?.institution_id.toString())
    setInst({
      _id: inst?._id,
      institution_name: inst?.institution_name,
      logo: inst?.logo,
    });
  }, []);

  // var cor_campus = null;
  // for (var i = 0; i < campuses.length; i++) {
  //   if (job.campus_id == campuses[i]._id) {
  //     cor_campus = campuses[i]
  //     break;
  //   }
  // }

  // const checkCampus = () => {
  //   for (var i = 0; i < campuses.length; i++) {
  //     if (job.campus_id == campuses[i]._id) {
  //       cor_campus = campuses[i]
  //       return campuses[i];
  //       break;
  //     }
  //   }

  //   return null
  // }

  // const checkInst = () => {
  //   if (cor_campus) {
  //     for (var i = 0; i < insts.length; i++) {
  //       if (insts[i]._id == cor_campus.institution_id) {
  //         return insts[i];
  //       }
  //     }
  //   }
  //   return null
  // }

  const classList = getClass();
  // let level = classList.find((cl) => cl.key === job.level);
  // level = level ? level.whole_name : job.level;
  let level = job.level

  
  const getValidStartDate = (job) => {
    return job.dates?.find(item => item.date >= job.booking_date)?.date
  }

  return (
    <ProfileBox header='Upcoming Class'>
      <div className='column upcoming-classes-wrapper pb-3'>
        <div className='d-flex flex-row justify-content-center align-items-center mb-3 booking-title'>
          <>
            <img src={inst.logo} className='job-card-logo-container' alt="college's avatar"/>
            <div>
              <h3 className='pl-1'>
                {inst.institution_name}
              </h3>
              <Link
                to={"/NavigateToCollegeSharedProfile?id=" + inst._id}
                target="blank"
              >
                <span className="job-card-tag">
                  <Icon name="share" size="large" />
                    View Profile
                </span>
              </Link>
            </div>
          </>
        </div>

        <div className='booking-details'>
          <p className='text-left card-content-classes'>
            Booking for{' '}
            <strong>
              <Moment format='MMMM DD, YYYY'>{job.multiple_date ? getValidStartDate(job) : job.booking_date}</Moment>
            </strong>
            {job.end_booking_date && job.booking_date !== job.end_booking_date && (
              <>
                {' '}
                to{' '}
                <strong>
                  <Moment format='MMMM DD, YYYY'>
                    {job.end_booking_date}
                  </Moment>
                </strong>
              </>
            )}
          </p>
          <p className='text-left card-content'>
            <Icon name='clock' />
            Arrive at <strong>{parseTime(job.arrival_time)}</strong> for{' '}
            <strong>{parseTime(job.start_time)}</strong> start, ends{' '}
            <strong>{parseTime(job.end_time)}</strong>
          </p>

          <p className='text-left card-content'>
            <Icon name='map marker alternate' />
            {campusAddress.join(', ')}
          </p>
          <p className='text-left card-content'>
            <span className='job-list-label'>Job</span>
            {level}
          </p>
          <p className='text-left card-content'>
            <span className='job-list-label'>Mode</span>
            {job.online ?
              job.deliver_from_home === undefined ? "Online"
                :
                (job.deliver_from_home ? "Online - Deliver from home" : "Online - Deliver on-campus")
              :
              "On Campus"}
          </p>

          <div className="card-link-bottom text-center">
            <Link to={`TeacherJobList#${job._id}`} className='card-content' style={{ color: "#4183c4" }}>
              <strong>View Job Details{' >>'}</strong>
            </Link>
          </div>

          {response &&
          job.teacher_response === teacherResponse.not_responded ? (
            <div>
              <div className='reject-accept-buttons-container'>
                <div className='column-fix'>
                  <CancelButton
                    className='button_cancel_accept'
                    onClick={() =>
                      submitResponse(
                        user_id,
                        job._id,
                        teacherResponse.rejected,
                        job.multiple_date,
                        job.split_index
                      )
                    }
                  >
                    Reject Job
                  </CancelButton>
                </div>
                {!isOverlap && (
                  <div className='column-fix'>
                    <ConfirmButton
                      className='button_cancel_accept'
                      onClick={() =>
                        submitResponse(
                          user_id,
                          job._id,
                          teacherResponse.accepted,
                          job.multiple_date,
                          job.split_index
                        )
                      }
                    >
                      Accept Job
                    </ConfirmButton>
                  </div>
                )}
              </div>
            </div>
          ) : null}

          {response && job.teacher_response === teacherResponse.accepted ? (
            <p className="text-center">
              <span className="job-list-label" style={{background: '#3bb4d8'}}>STATUS</span>
              <span className='card-content font-weight-bold'>Confirmed</span>
            </p>
          ) : null}

          {response && job.teacher_response === teacherResponse.rejected ? (
            <p className="text-center">
              <span className='job-list-label' style={{background: '#3bb4d8'}}>STATUS</span>
              <span className='card-content font-weight-bold'>Rejected</span>
            </p>
          ) : null}
        </div>
      </div>
    </ProfileBox>
  );
};

const checkOverlap = (booking, job) => {
  var bookingArrivalTime = new Date();
  var bookingEndTime = new Date();
  var jobArrivalTime = new Date();
  var jobEndTime = new Date();

  bookingArrivalTime.setHours(
    booking.arrival_time.split(':')[0],
    booking.arrival_time.split(':')[1],
    booking.arrival_time.split(':')[2],
    0
  );
  bookingEndTime.setHours(
    booking.end_time.split(':')[0],
    booking.end_time.split(':')[1],
    booking.end_time.split(':')[2],
    0
  );

  jobArrivalTime.setHours(
    job.arrival_time.split(':')[0],
    job.arrival_time.split(':')[1],
    job.arrival_time.split(':')[2],
    0
  );
  jobEndTime.setHours(
    job.end_time.split(':')[0],
    job.end_time.split(':')[1],
    job.end_time.split(':')[2],
    0
  );

  if (bookingArrivalTime <= jobEndTime && jobArrivalTime <= bookingEndTime) {
    return true;
  }
  return false;
};

function mapStateToProps(state) {
  return {
    user_id: state.user.user._id,
  };
}

export default connect(mapStateToProps)(JobComponent);
